// angular
import { Directive, ElementRef, HostListener, inject } from '@angular/core';
// other libraries
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

@Directive({
  selector: '[horizontalScroll]',
  standalone: true,
})
export class HorizontalScrollDirective {
  public mouseStoppedTimer: number = 0;
  public timer: undefined | ReturnType<typeof setTimeout>;

  // dependencies
  private readonly element = inject(ElementRef);

  constructor() {}

  // horizontal scroll functionality
  @HostListener('wheel', ['$event'])
  public onScroll(event: WheelEvent) {
    // calculate max scroll left
    const maxScrollLeft =
      this.element.nativeElement.scrollWidth -
      this.element.nativeElement.clientWidth;

    // check if its end of scroll then enable body scroll
    if (
      (this.element.nativeElement.scrollLeft === 0 && event.deltaY < 0) ||
      (this.element.nativeElement.scrollLeft === maxScrollLeft &&
        event.deltaY > 0)
    ) {
      enableBodyScroll(this.element.nativeElement);
    } else {
      // set amount of scroll
      if (event.deltaY < 0) {
        this.element.nativeElement.scrollLeft += event.deltaY - 50;
      } else {
        this.element.nativeElement.scrollLeft += event.deltaY + 50;
      }
    }
  }

  // handle body scroll on mouse move
  // @HostListener('mousemove', ['$event'])
  // public onMouseMove(event: WheelEvent) {
  // }

  // disable body scroll when horizontal scroll
  @HostListener('mouseenter', ['$event'])
  public onMouseEnter(event: MouseEvent) {
    // Disable body scroll
    disableBodyScroll(this.element.nativeElement);
  }

  // enable body scroll when horizontal scroll finished
  @HostListener('mouseleave', ['$event'])
  public onMouseLeave(event: MouseEvent) {
    //  Re-enable body scroll
    enableBodyScroll(this.element.nativeElement);
  }

  // enable body scroll
  ngOnDestroy() {
    clearAllBodyScrollLocks();
  }
}
